// firebase.js — C:\JR\dartfun\src\firebase.js
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyCtBT0BNq0PdbykLgUJhWVQA775MoF_EoQ",
  authDomain: "dartsforfun.firebaseapp.com",
  projectId: "dartsforfun",
  storageBucket: "dartsforfun.firebasestorage.app",
  messagingSenderId: "950107046488",
  appId: "1:950107046488:web:5a900ea2991d7646b4002d",
  measurementId: "G-V96K0XD8GR",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };